import React from 'react';
import { CONTACT_EMAIL } from '../../utils/site';
import { PageHelmet } from '../shared/PageHelmet/PageHelmet';
import styles from './PrivacyPolicyPage.module.css';

export const PrivacyPolicyPage = () => {
  return (
    <div className={styles.container}>
      <PageHelmet
        path="/privacy-policy"
        title="개인정보처리방침 | 노후든든"
        description="노후든든의 개인정보처리방침입니다. 사이트 이용자의 개인정보를 어떻게 수집, 이용, 보호하는지에 대한 정보를 제공합니다."
      />
      <h1>개인정보처리방침</h1>
      <p>최종 수정일: 2026년 3월 17일</p>

      <h2>1. 총칙</h2>
      <p>
        노후든든(이하 '사이트')은 이용자의 개인정보를 중요시하며, 정보통신망 이용촉진 및 정보보호 등에 관한 법률을 준수하고 있습니다.
        사이트는 개인정보처리방침을 통하여 이용자가 제공하는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.
      </p>

      <h2>2. 수집하는 개인정보 항목</h2>
      <p>
        사이트는 별도의 회원가입 절차 없이 대부분의 콘텐츠에 자유롭게 접근할 수 있습니다. 일부 서비스 이용 과정에서 다음과 같은 정보들이 자동으로 생성되어 수집될 수 있습니다.
      </p>
      <ul>
        <li>IP 주소, 쿠키, 방문 일시, 서비스 이용 기록, 불량 이용 기록</li>
      </ul>

      <h2>3. 개인정보의 수집 및 이용목적</h2>
      <p>사이트는 수집한 개인정보를 다음의 목적을 위해 활용합니다.</p>
      <ul>
        <li>서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금 정산</li>
        <li>콘텐츠 제공, 맞춤 서비스 제공</li>
        <li>회원 관리: 개인 식별, 불량회원의 부정 이용 방지와 비인가 사용 방지</li>
        <li>마케팅 및 광고에 활용: 신규 서비스 개발 및 맞춤 서비스 제공, 접속 빈도 파악 또는 회원의 서비스 이용에 대한 통계</li>
      </ul>

      <h2>4. 쿠키에 의한 개인정보 수집</h2>
      <p>
        사이트는 이용자에게 특화된 맞춤 서비스를 제공하기 위해서 이용자들의 정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다.
        쿠키는 웹사이트를 운영하는데 이용되는 서버(HTTP)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다.
      </p>
      <p>
        이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 이용자는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.
      </p>

      <h2>5. 광고 서비스</h2>
      <p>
        사이트는 Google AdSense와 같은 제3자 광고 서비스를 이용할 수 있습니다. 이러한 광고 서비스 제공업체는 사용자에게 보다 관련성 높은 광고를 제공하기 위해 쿠키를 사용할 수 있습니다.
      </p>
      <ul>
        <li>Google을 포함한 제3자 공급업체는 쿠키를 사용하여 사용자의 이전 웹사이트 방문 기록을 기반으로 광고를 게재합니다.</li>
        <li>Google의 광고 쿠키 사용을 통해 Google 및 Google 파트너는 사용자의 사이트 및/또는 다른 사이트 방문 기록을 기반으로 사용자에게 광고를 표시할 수 있습니다.</li>
        <li>사용자는 <a href="https://adssettings.google.com/authenticated" target="_blank" rel="noopener noreferrer">광고 설정</a>에서 맞춤 광고를 선택 해제할 수 있습니다.</li>
      </ul>

      <h2>6. 개인정보의 보유 및 이용기간</h2>
      <p>
        원칙적으로, 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 단, 관계법령의 규정에 의하여 보존할 필요가 있는 경우 사이트는 아래와 같이 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다.
      </p>

      <h2>7. 개인정보에 관한 민원서비스</h2>
      <p>
        사이트는 이용자의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 관련 부서 및 개인정보관리책임자를 지정하고 있습니다.
      </p>
      <ul>
        <li><strong>문의처:</strong> <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a></li>
      </ul>
      <p>
        기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.
      </p>
      <ul>
        <li>개인정보침해신고센터 (<a href="http://privacy.kisa.or.kr" target="_blank" rel="noopener noreferrer">privacy.kisa.or.kr</a> / 국번없이 118)</li>
        <li>대검찰청 사이버수사과 (<a href="http://www.spo.go.kr" target="_blank" rel="noopener noreferrer">www.spo.go.kr</a> / 국번없이 1301)</li>
        <li>경찰청 사이버안전국 (<a href="http://cyberbureau.police.go.kr" target="_blank" rel="noopener noreferrer">cyberbureau.police.go.kr</a> / 국번없이 182)</li>
      </ul>
    </div>
  );
};
